import { useGlobalData } from '@/context/global';
import { loginotpsend, loginotpverify } from '@/services/auth';
import { loginOtpValidation } from '@/utils/valitation/auth';
import { getCookie } from 'cookies-next';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { signIn } from 'next-auth/react';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';

const RESEND_COOLDOWN_SECONDS = 60;

function LoginVerifyOtp({ t, setAuth, setShow }) {
  const { appData: { mobile } } = useGlobalData();
  const [secondsLeft, setSecondsLeft] = useState(RESEND_COOLDOWN_SECONDS);
  const [isResending, setIsResending] = useState(false);

  // Timer for resend otp.
  const intervalRef = useRef(null);

  useEffect(() => {
    if (secondsLeft <= 0) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [secondsLeft]);

  // Resend OTP handler.
  const handleResendOtp = async () => {
    if (secondsLeft > 0 || isResending) return;

    const handshake = getCookie('handshake');
    setIsResending(true);

    try {
      const res = await loginotpsend(handshake, mobile);

      if (!res?.data && res?.error?.success == 'false') {
        toast.error(t(res.error?.error || 'Something went wrong'));
      } else {
        toast.success(res?.data?.data?.successmsg || t('OTP sent successfully'));
        setSecondsLeft(RESEND_COOLDOWN_SECONDS);
      }
    } catch (error) {
      toast.error(t('Something went wrong'));
    } finally {
      setIsResending(false);
    }
  };
  const handleVerifyOtp = async (values, { setSubmitting }) => {
    const handshake = getCookie('handshake');
    setSubmitting(true);
    const res = await loginotpverify(handshake, mobile, values.otp);
    if (!res?.data && res?.error?.success == 'false') {
      toast.error(t(res.error?.error || 'Something went wrong'));
      setSubmitting(false);
    } else {
      if (res?.data?.user?.addresses) {
        delete res.data.user.addresses;
      }
      signIn('credentials', {
        redirect: false,
        data: JSON.stringify(res?.data || {})
      }).then(({ ok, status, error }) => {
        if (ok && status === 200 && !error) {
          setAuth('');
          toast.success(res?.data?.data?.successmsg || t('Login successful'));
          setAuth('');
        }
      });
      setSubmitting(false);
    }
  };

  return (
    <section className='mt-3 sm:mt-5'>
      <Formik
        onSubmit={handleVerifyOtp}
        initialValues={{
          otp: '',
        }}
        validationSchema={loginOtpValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form>
            <p className='text-sm font-semibold'>
              {t('Please enter the OTP has been sent on your mobile number')}{' '}
              {mobile?.slice(-10)}
            </p>
            <div className='flex flex-col gap-3 mt-4 text-start'>
              <label htmlFor='otp'>{t('OTP')}</label>
              <Field
                className='flex-grow w-full outline-none max-sm:text-sm max-sm:placeholder:text-sm sm:p-2 border rounded-md border-gray-300'
                name='otp'
                placeholder={t('Enter your OTP')}
                type='text'
                id='otp'
              />
              <ErrorMessage
                name='otp'
                component='div'
                className='mt-1 text-sm text-red-600 max-sm:text-xs'
              />
            </div>
            <div className='text-sm'>
              {t('change mobile number?')}{' '}
              <span
                onClick={() => setShow('sendotp')}
                className='cursor-pointer text-primary'
              >
                {t('Click here')}
              </span>
            </div>
            <div className='text-sm mt-2 text-center'>
              {isResending && (
                <span className='inline-block border-2 border-t border-r border-primary rounded-full size-3 animate-spin mx-1' />
              )}
              <span
                onClick={secondsLeft > 0 || isResending ? undefined : handleResendOtp}
                className={`text-primary ${secondsLeft > 0 || isResending
                  ? 'opacity-50 cursor-not-allowed'
                  : 'cursor-pointer hover:underline'
                  }`}
              >
                {secondsLeft > 0
                  ? `${t('Resend OTP')} (${secondsLeft}s)`
                  : t('Resend OTP')}
              </span>
            </div>
            <button
              disabled={isSubmitting}
              className='flex items-center justify-center w-full gap-4 p-2 mt-4 font-semibold text-white rounded-md bg-primary hover:bg-primary/90 max-sm:text-sm'
            >
              {isSubmitting && (
                <span className='border-2 border-t border-r border-white rounded-full size-4 animate-spin' />
              )}
              <span>{t('Verify OTP')}</span>
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
}

export default LoginVerifyOtp;
